import {makeAutoObservable, transaction} from "mobx";
import {SpecimenEntity} from "../entity/specimen-entity";
import {searchDataApi} from "../http/home";
import {PageEntity} from "../entity/page-entity";
import {ImageInfoEntity} from "../entity/image-info-entity";
import {AtlasEntity} from "../entity/atlas-entity";
import {ScienceEntity} from "../entity/science-entity";

export class SearchGlobalStore {

    constructor() {
        makeAutoObservable(this);
    }


    public recordDataSource: SpecimenEntity[] = []; // 标本
    public libraryDataSource: ImageInfoEntity[] = []; // 原植物图库
    public atlasDataSource: AtlasEntity[] = []
    public dnaDataSource: AtlasEntity[] = []
    public pictureDataSource: [] = [];
    public publicityDataSource: ScienceEntity[] = [];
    public detailModalOpen: boolean = false;
    public searchWord: string = "";
    public recordCollapse: string[] = ["", "", "", "", ""];
    public recordDetailModalOpen: boolean = false;
    public libraryDetailModalOpen: boolean = false;
    public atlasDetailModalOpen: boolean = false;
    public dnaDetailModalOpen: boolean = false;
    public plantDetail!: SpecimenEntity;
    public libraryDetail!: ImageInfoEntity;
    public atlasDetail!: AtlasEntity;
    public dnaDetail!: AtlasEntity;
    public recordPagination: PageEntity = this.getDefaultPagination()
    public libraryPagination: PageEntity = this.getDefaultPagination()
    public atlasPagination: PageEntity = this.getDefaultPagination()
    public dnaPagination: PageEntity = this.getDefaultPagination()
    public sciencePagination: PageEntity = this.getDefaultPagination()

    private getDefaultPagination() {
        const pagination = new PageEntity();
        pagination.pageSize = 5;
        return pagination
    }


    public setDetailModalOpen(open: boolean) {
        this.detailModalOpen = open;
    }

    public setSearchWord(searchWord: string) {
        this.searchWord = searchWord;
    }

    public setRecordDetailModal(show: boolean) {
        this.recordDetailModalOpen = show;
    }

    public setPlantDetail(detail: SpecimenEntity) {
        this.plantDetail = detail;
    }

    public setLibraryDetailModal(isShow: boolean) {
        this.libraryDetailModalOpen = isShow;
    }

    public setLibraryDetailEntity(detailEntity: ImageInfoEntity) {
        this.libraryDetail = detailEntity;
    }

    public queryGlobal = (type: string, pageNum = 1) => {
        const params = {
            type,
            pageNum,
            pageSize: 5,
            searchKey: this.searchWord,
        }
        // 1.标本2.原植物图库3.科普4.图谱5.dna
        searchDataApi(params)
            .then((res) => {
                if (res && res.data) {
                    const dataType = Number(res.data.type);
                    if (dataType === 1) {
                        this.recordPagination.total = res.data.specimenInfo ? res.data.specimenInfo.total : 0
                        this.recordPagination.pageNum = pageNum
                        this.recordDataSource = res.data.specimenInfo.list
                    } else if (dataType === 2) {
                        this.libraryPagination.total = res.data.imageInfo ? res.data.imageInfo.total : 0
                        this.libraryPagination.pageNum = pageNum
                        this.libraryDataSource = res.data.imageInfo.list
                    } else if (dataType === 3) {
                        this.sciencePagination.total = res.data.popularScience ? res.data.popularScience.total : 0
                        this.sciencePagination.pageNum = pageNum
                        this.refreshList(res.data.popularScience.list)
                    } else if (dataType === 4) {
                        this.atlasPagination.total = res.data.atlasLibrary ? res.data.atlasLibrary.total : 0
                        this.atlasPagination.pageNum = pageNum
                        this.atlasDataSource = res.data.atlasLibrary.list
                    } else if (dataType === 5) {
                        this.dnaPagination.total = res.data.dna ? res.data.dna.total : 0
                        this.dnaPagination.pageNum = pageNum
                        this.dnaDataSource = res.data.dna.list
                    } else {
                        transaction(() => {
                            if (!res.data) return
                            this.recordPagination.total = res.data.specimenInfo ? res.data.specimenInfo.total : 0
                            this.recordPagination.pageNum = pageNum
                            this.recordDataSource = res.data.specimenInfo.list
                            this.libraryPagination.total = res.data.imageInfo ? res.data.imageInfo.total : 0
                            this.libraryPagination.pageNum = pageNum
                            this.libraryDataSource = res.data.imageInfo.list
                            this.atlasPagination.total = res.data.atlasLibrary ? res.data.atlasLibrary.total : 0
                            this.atlasPagination.pageNum = pageNum
                            this.atlasDataSource = res.data.atlasLibrary.list
                            this.dnaPagination.total = res.data.dna ? res.data.dna.total : 0
                            this.dnaPagination.pageNum = pageNum
                            this.dnaDataSource = res.data.dna.list
                            this.sciencePagination.total = res.data.popularScience ? res.data.popularScience.total : 0
                            this.sciencePagination.pageNum = pageNum
                            this.refreshList(res.data.popularScience.list)
                            this.refreshCollapse()
                        })
                    }
                }
            }).catch((e) => {
            console.log("error:"+e.message)
        })
    }

    private refreshCollapse = () => {
        this.recordCollapse[0] = this.isListEmpty(this.recordDataSource) ? "record" : ""
        this.recordCollapse[1] = this.isListEmpty(this.libraryDataSource) ? "library" : ""
        this.recordCollapse[2] = this.isListEmpty(this.atlasDataSource) ? "picture" : ""
        this.recordCollapse[3] = this.isListEmpty(this.dnaDataSource) ? "dna" : ""
        this.recordCollapse[4] = this.isListEmpty(this.publicityDataSource) ? "publicity" : ""
    }

    private isListEmpty = (list: any[]) => {
        return list && list.length > 0
    }

    public refreshList = (data: ScienceEntity[]) => {
        this.publicityDataSource = []
        data.forEach((item: ScienceEntity) => {
            item.key = String(item.id);
            this.publicityDataSource.push(item)
        })
    }


    public clear = () => {
        this.detailModalOpen = false;
        this.searchWord = "";
        this.recordDataSource = [];
        this.libraryDataSource = [];
        this.dnaDataSource = [];
        this.publicityDataSource = [];
        this.pictureDataSource = []
        this.atlasDataSource = []
        this.recordCollapse = ["", "", "", "", ""];
        this.recordDetailModalOpen = false;
        this.recordCollapse = [];
        this.libraryPagination = this.getDefaultPagination()
        this.recordPagination = this.getDefaultPagination()
        this.atlasPagination = this.getDefaultPagination()
        this.dnaPagination = this.getDefaultPagination()
        this.sciencePagination = this.getDefaultPagination()
        this.recordDetailModalOpen = false
        this.atlasDetailModalOpen = false;
        this.dnaDetailModalOpen = false;
    }
}